import api from '@/api'
import notifier from '@/notifier'

export default {
  namespaced: true,
  state: {
    logs: [],
    total: 0,
    fetching: false,
    lastFetchOptions: null
  },
  actions: {
    async fetch ({ state, commit, getters }, { options }) {
      commit('fetching')

      try {
        const { total, items } = await api.getLogs(options)

        commit('setFetchData', {
          total, items, options
        })
      } catch (error) {
        state.total = 0
        state.logs = []
        state.lastFetchOptions = {...options}

        if (error.response.status !== 404) {
          notifier.error('Falha ao buscar os históricos.', 'Erro')
        }
      }
    },
    async fetchMore ({ state, commit, getters }, { options }) {
      commit('fetching')

      try {
        const { total, items } = await api.getLogs(options)

        for (let i in items) {
          state.logs.push(items[i])
        }

        state.total = total
      } catch (error) {
        options.finished = true

        if (error.response.status !== 404) {
          notifier.error('Falha ao buscar os históricos.', 'Erro')
        }
      }
    },
    async fetchApi ({ state, commit, getters }, { options }) {
      commit('fetching')

      try {
        const { total, items } = await api.getApiLogs(options)

        commit('setFetchData', {
          total, items, options
        })
      } catch (error) {
        state.total = 0
        state.logs = []
        state.lastFetchOptions = {...options}

        if (error.response.status !== 404) {
          notifier.error('Falha ao buscar os históricos.', 'Erro')
        }
      }
    },
    async fetchMoreApi ({ state, commit, getters }, { options }) {
      commit('fetching')

      try {
        const { total, items } = await api.getApiLogs(options)

        for (let i in items) {
          state.logs.push(items[i])
        }

        state.total = total
      } catch (error) {
        options.finished = true

        if (error.response.status !== 404) {
          notifier.error('Falha ao buscar os históricos.', 'Erro')
        }
      }
    }
  },
  mutations: {
    setFetchData (state, { total, items, options }) {
      state.total = total
      state.logs = items
      state.lastFetchOptions = {...options}
      state.fetching = false
    },
    fetching (state) {
      state.fetching = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/logs.js